import { render, staticRenderFns } from "./PublicBookAppointment.vue?vue&type=template&id=af4bba0a&scoped=true&"
import script from "./PublicBookAppointment.vue?vue&type=script&lang=js&"
export * from "./PublicBookAppointment.vue?vue&type=script&lang=js&"
import style0 from "./PublicBookAppointment.vue?vue&type=style&index=0&id=af4bba0a&scoped=true&lang=css&"
import style1 from "./PublicBookAppointment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4bba0a",
  null
  
)

export default component.exports